// libs
import axios from 'axios'

// methods
export const isCancelError = (error) => axios.isCancel(error)

export const createCancelPreviousRequest = () => {
  let cancelSource = null
  let latestRequestId = 0

  const start = (cancelMessage = 'Canceled because a newer request started') => {
    latestRequestId += 1
    const requestId = latestRequestId

    if (cancelSource) {
      cancelSource.cancel(cancelMessage)
    }

    cancelSource = axios.CancelToken.source()

    return {
      cancelToken: cancelSource.token,
      isLatest: () => requestId === latestRequestId,
    }
  }

  const cancel = (message = 'Canceled') => {
    if (!cancelSource) return

    cancelSource.cancel(message)
    cancelSource = null
  }

  return { start, cancel }
}

